import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'globalSearch'
})
export class GlobalSearchPipe implements PipeTransform {

  transform(value: any, searchText: any): any {
    let dateFormat = require('dateformat');
    console.log("GlobalSearchPipe",value,searchText);
      let now = new Date();
    console.log("value",value)
    if(searchText==" "|| searchText==""){
      return value;
    }

    else {
    value= value.filter((x:any) => 
    searchText===" " ||
    searchText.length==0 ||
    x.scheduled_date.indexOf(searchText)>= 0||
    dateFormat(x.scheduled_date, "dd-mm-yyyy HH:MM:ss").indexOf(searchText)>= 0||
    x.driver.name.indexOf(searchText)>= 0 ||
    x.driver.name.toLowerCase().indexOf(searchText.toLowerCase())>= 0 ||
    // x.loc!=null?(x.loc.start_address!=null?x.loc.start_address.address.indexOf(searchText)>= 0:''):''||
    // x.loc!=null?(x.loc.end_address!=null?x.loc.end_address.address.indexOf(searchText)>= 0 :''):''||
    // x.start_address.indexOf(searchText)>= 0 ||
    // x.end_address.indexOf(searchText)>= 0 ||
   ( x.trip_type==0 && "Pick Up".indexOf(searchText)>= 0 )||
   ( x.trip_type==0 && "pick up".indexOf(searchText.toLowerCase())>= 0 )||
   ( x.trip_type==0 && "pickup".indexOf(searchText.toLowerCase())>= 0 )||
   ( x.trip_type==1 && "Drop".indexOf(searchText)>= 0 ) ||
   ( x.trip_type==1 && "drop".indexOf(searchText.toLowerCase())>= 0 ) ||
   ( x.status==0 && "Not Started".indexOf(searchText)>= 0 )||
   ( x.status==0 && "not started".indexOf(searchText.toLowerCase())>= 0 )||
   ( x.status==1 && "Started".indexOf(searchText)>= 0 ) ||
   ( x.status==1 && "started".indexOf(searchText.toLowerCase())>= 0 ) ||
   ( x.status==2 && "Completed".indexOf(searchText)>= 0 )||
   ( x.status==2 && "completed".indexOf(searchText.toLowerCase())>= 0 )


     )

     console.log("value",value)
  return value;
}

  }

}
